module.exports = __webpack_public_path__ + "img/Pattern02.120ddd3e.png";